import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useContacts } from "./useContacts";
import ContactsListView from "./contactList";
import ContactsGridView from "./contactGrid";
import { AuthContext } from "../../../context/authcontext";

type ViewType = "list" | "grid";

const ContactsContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedTenantId } = useContext(AuthContext);

  const getCurrentView = (): ViewType => {
    return location.pathname.includes("contact-grid") ? "grid" : "list";
  };

  const [currentView, setCurrentView] = useState<ViewType>(getCurrentView());

  const contactsData = useContacts();

  useEffect(() => {
    setCurrentView(getCurrentView());
  }, [location.pathname]);

  useEffect(() => {
    if (selectedTenantId && !contactsData.isInitialized) {
      contactsData.fetchContacts(1);
    }
  }, [selectedTenantId, contactsData.isInitialized]);

  const handleViewSwitch = (view: ViewType) => {
    const newPath =
      view === "grid" ? all_routes.contactGrid : all_routes.contactList;
    navigate(newPath, { replace: true });
  };

  const sharedProps = {
    ...contactsData,
    currentView,
    onViewSwitch: handleViewSwitch,
  };

  return (
    <>
      {currentView === "list" ? (
        <ContactsListView {...sharedProps} />
      ) : (
        <ContactsGridView {...sharedProps} />
      )}
    </>
  );
};

export default ContactsContainer;
